import { render } from "./_directory.vue?vue&type=template&id=75b85148"
import script from "./_directory.vue?vue&type=script&lang=js"
export * from "./_directory.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/staging.no-menu.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__